import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { determineSignupFlow, markSignupSubmitted, SIGNUP_FLOW_FIELD_ID } from './signup-flow.logic';

/**
 * 会員登録フロー種別フィールド
 *
 * @element kd-signup-flow-field
 * @description 会員登録フォームの hidden input（customer[note][signup_flow]）に
 *              sessionStorage から判定した導線種別（cart / view / direct）をセットする。
 *              note に入った値は Shopify Flow「会員登録後に、noteをmetafieldにcopy」で
 *              顧客 metafield customer.signup_flow へコピーされる（誕生日・性別・UTM と同じ経路）。
 *              フォーム送信時に送信済みマーカーを記録し、完了ページの計測はそのマーカーがある場合のみ行う。
 */
@customElement('kd-signup-flow-field')
export class KdSignupFlowField extends LitElement {
  createRenderRoot() {
    return this;
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.applySignupFlow();
  }

  private applySignupFlow(): void {
    const form = this.closest('form');
    const input =
      form?.querySelector<HTMLInputElement>(`#${SIGNUP_FLOW_FIELD_ID}`) ??
      document.getElementById(SIGNUP_FLOW_FIELD_ID);

    if (!(input instanceof HTMLInputElement)) return;

    input.disabled = false;
    input.value = determineSignupFlow();

    (form ?? input.form)?.addEventListener('submit', markSignupSubmitted);
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-signup-flow-field': KdSignupFlowField;
  }
}
